const locales = {
  fr: {
    online: 'En ligne',
    clearHistory: "Supprimer l'historique",
    newConversationAction: 'Nouvelle conversation',
    newConversation: 'Nouvelle conversation',
    newConversationPrompt: 'Démarrer une nouvelle conversation ?',
    newConversationStarted: 'Nouvelle conversation démarrée',
    cancel: 'Annuler',
    conversations: 'Conversations',
    viewConversations: 'Voir les conversations',
    backToChat: 'Retour à la conversation',
    emptyConversation: 'Nouvelle conversation',
    noConversations: 'Aucune conversation pour le moment',
    close: 'Fermer',
    openChat: 'Ouvrir le chat',
    privacyPolicyTitle: 'Politique de confidentialité',
    consentText: 'Vos messages seront envoyés à une intelligence artificielle externe pour traitement.',
    consentLinkText: 'Consultez notre politique de traitement des données',
    consentMore: "pour plus d'informations.",
    consentCheckbox: "J'ai lu et j'accepte la politique de traitement des données",
    decline: 'Refuser',
    accept: 'Accepter',
    inputPlaceholder: 'Votre message...',
    send: 'Envoyer',
    aiDisclaimer: "L'IA peut faire des erreurs. Vérifiez les informations importantes.",
    poweredBy: 'Propulsé par',
    historyCleared: 'Historique supprimé',
    recommendedProducts: 'Produits recommandés',
    productCount: (n) => `${n} ${n > 1 ? 'produits' : 'produit'}`,
    viewProduct: 'Voir le produit',
    productFallbackName: 'Produit',
    errorNoResponse: "Désolé, je n'ai pas pu obtenir de réponse.",
    errorProcessing: "Désolé, je n'ai pas pu traiter cette réponse.",
    errorCommunication: "Désolé, une erreur s'est produite lors de la communication avec le service.",
    errorTimeout: 'Le service met trop de temps à répondre. Veuillez réessayer.',
    errorOffline: 'Connexion impossible. Vérifiez votre réseau et réessayez.',
    errorServer: 'Le service est momentanément indisponible. Réessayez dans quelques instants.',
    errorRateLimited: 'Trop de messages envoyés. Patientez un instant avant de réessayer.',
    errorAuth: 'Accès refusé. Veuillez recharger la page.',
    rateLimited: "Veuillez patienter avant d'envoyer un nouveau message.",
    messageSent: 'Envoyé',
    messageSeen: 'Vu',
    darkMode: 'Mode sombre',
    lightMode: 'Mode clair',
    thinking: 'Réflexion en cours',
    conversation: 'Conversation',
    prevSlide: 'Produit précédent',
    nextSlide: 'Produit suivant',
    slideOf: (current, total) => `Produit ${current} sur ${total}`,
    productSlider: 'Carrousel de produits',
    leadFormTitle: 'Vos coordonnées',
    leadFormFieldset: 'Formulaire de contact',
    leadFormSubmit: 'Envoyer',
    leadFormSending: 'Envoi en cours…',
    leadFormSent: 'Envoyé',
    leadFormSuccess: 'Merci ! Nous vous recontacterons bientôt.',
    leadFormError: "L'envoi a échoué, veuillez réessayer.",
    leadFormSubmitted: 'Formulaire envoyé',
    leadFormConsentDefault: "J'accepte d'être recontacté(e)",
    leadFormConsentRequired: 'Merci de cocher la case pour continuer',
    leadFormErrorRequired: 'Ce champ est obligatoire',
    leadFormErrorTooLong: 'Valeur trop longue',
    leadFormErrorEmail: 'Adresse e-mail invalide',
    leadFormErrorPhone: 'Numéro de téléphone invalide',
    leadFormErrorGeneric: 'Valeur invalide',
    leadFormSummaryFallback: 'Coordonnées envoyées',
    leadFormRequiredHint: 'champ obligatoire'
  },
  en: {
    online: 'Online',
    clearHistory: 'Clear history',
    newConversationAction: 'New conversation',
    newConversation: 'New conversation',
    newConversationPrompt: 'Start a new conversation?',
    newConversationStarted: 'New conversation started',
    cancel: 'Cancel',
    conversations: 'Conversations',
    viewConversations: 'View conversations',
    backToChat: 'Back to conversation',
    emptyConversation: 'New conversation',
    noConversations: 'No conversations yet',
    close: 'Close',
    openChat: 'Open chat',
    privacyPolicyTitle: 'Privacy Policy',
    consentText: 'Your messages will be sent to an external AI for processing.',
    consentLinkText: 'View our data processing policy',
    consentMore: 'for more information.',
    consentCheckbox: 'I have read and accept the data processing policy',
    decline: 'Decline',
    accept: 'Accept',
    inputPlaceholder: 'Your message...',
    send: 'Send',
    aiDisclaimer: 'AI can make mistakes. Please double-check important information.',
    poweredBy: 'Powered by',
    historyCleared: 'History cleared',
    recommendedProducts: 'Recommended products',
    productCount: (n) => `${n} ${n > 1 ? 'products' : 'product'}`,
    viewProduct: 'View product',
    productFallbackName: 'Product',
    errorNoResponse: "Sorry, I couldn't get a response.",
    errorProcessing: "Sorry, I couldn't process this response.",
    errorCommunication: 'Sorry, an error occurred while communicating with the service.',
    errorTimeout: 'The service is taking too long to respond. Please try again.',
    errorOffline: 'Unable to connect. Check your network and try again.',
    errorServer: 'The service is temporarily unavailable. Please try again shortly.',
    errorRateLimited: 'Too many messages sent. Please wait a moment before retrying.',
    errorAuth: 'Access denied. Please reload the page.',
    rateLimited: 'Please wait before sending another message.',
    messageSent: 'Sent',
    messageSeen: 'Seen',
    darkMode: 'Dark mode',
    lightMode: 'Light mode',
    thinking: 'Thinking',
    conversation: 'Conversation',
    prevSlide: 'Previous product',
    nextSlide: 'Next product',
    slideOf: (current, total) => `Product ${current} of ${total}`,
    productSlider: 'Product carousel',
    leadFormTitle: 'Your contact details',
    leadFormFieldset: 'Contact form',
    leadFormSubmit: 'Send',
    leadFormSending: 'Sending…',
    leadFormSent: 'Sent',
    leadFormSuccess: "Thanks! We'll get back to you shortly.",
    leadFormError: 'Submission failed, please try again.',
    leadFormSubmitted: 'Form submitted',
    leadFormConsentDefault: 'I agree to be contacted',
    leadFormConsentRequired: 'Please tick the box to continue',
    leadFormErrorRequired: 'This field is required',
    leadFormErrorTooLong: 'Value too long',
    leadFormErrorEmail: 'Invalid email address',
    leadFormErrorPhone: 'Invalid phone number',
    leadFormErrorGeneric: 'Invalid value',
    leadFormSummaryFallback: 'Contact details sent',
    leadFormRequiredHint: 'required'
  }
};

export function getTranslations(lang) {
  return locales[lang] || locales.fr;
}
